// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app .thumbnails {\r\n    display: inline-block;\r\n    font-size: 0px;\r\n    margin: -5vh auto 2vh auto;\r\n    text-align: center;\r\n}\r\n\r\n@media screen and (max-height: 1340px) {\r\n\r\n    .app > .thumbnails {\r\n        margin-bottom: 1vh;\r\n    }\r\n}\r\n", ""]);
// Exports
module.exports = exports;
